<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Configuração da Marca em Documentos'">
          <template v-slot:preview>
            <v-row>
              <v-col cols="5">
                <form>
                  <v-row style="gap: 1rem">
                    <v-chip
                      color="blue"
                      filter
                      label
                      link
                      outlined
                      v-for="n in keys"
                      :key="n"
                      @click="() => keyClick(n)"
                    >
                      {{ n }}
                    </v-chip>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea
                        label="Marca"
                        clearable
                        required
                        v-model="marcaConfig.marcaTemplate"
                        rows="3"
                        ref="text-marca"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-radio-group v-model="marcaConfig.posicao" row>
                    <template v-slot:label>
                      <div>
                        Selecione a posição da
                        <strong>Marca no documento</strong>
                      </div>
                    </template>
                    <v-radio label="Esquerda" :value="0"></v-radio>
                    <v-radio label="Direita" :value="1"></v-radio>
                    <v-radio label="Superior" :value="2"></v-radio>
                    <v-radio label="Inferior" :value="3"></v-radio>
                  </v-radio-group>
                  <v-row>
                    <v-col>
                      <v-text-field
                        label="Tamanho da Fonte"
                        clearable
                        required
                        v-model="marcaConfig.tamanhoFonte"
                        rows="3"
                      ></v-text-field>
                    </v-col>
                    <v-col align-self="center">
                      <v-btn
                        text
                        id="color-pick"
                        @click.stop="inputClick"
                        ref="colorPickRef"
                        :color="colorBotao"
                        title="Cor da Fonte"
                        elevation="2"
                      >
                        Cor da Fonte
                        <v-color-picker
                          v-if="showColorPick"
                          v-model="picker"
                          elevation="15"
                          hide-inputs
                          @update:color="definirCorMarcaConfig"
                        ></v-color-picker>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-switch                      
                      label="Exibir Logo"
                      v-model="marcaConfig.exibirLogo"
                    ></v-switch>
                    </v-col>                    
                  </v-row>
                  <v-row>                    
                    <v-col v-if="marcaConfig.exibirLogo">
                      <v-slider hide-details max="100" min="0" label="Opacidade" v-model="marcaConfig.opacidade"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn
                        @click="salvarConfiguracao"
                        color="primary"
                        :disabled="saving"
                        >Salvar</v-btn
                      ></v-col
                    >
                  </v-row>
                </form>
              </v-col>
              <v-col>
                <PDFJSViewer
                  :fileName="arquivoVisualizacao"
                  style="max-height: 500px"
                ></PDFJSViewer>
              </v-col>
            </v-row>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <TelaLoading :overlay="saving"></TelaLoading>
  </div>
</template>

<script>
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import TelaLoading from "@/views/components/TelaLoading.vue";
import PDFJSViewer from "../../../components/PDFJSViewer/PDFJSViewer.vue";
import MarcaDocumentoConfigService from "../../../../common/services/http/marcadocumento.service";

export default {
  name: "configuracoesDocumento",
  data() {
    return {
      picker: {},
      marca: "",
      posicao: 1,
      saving: false,
      showColorPick: false,
      fonte: "",
      marcaConfig: {
        marcaTemplate:
          "Arquivo de impressão gerado em {Data-Abreviada} às {Hora-Abreviada} para o usuário {ID}-{Nome}",
        posicao: 0,
        corFonte: { A: 1, R: 255, G: 0, B: 0 },
        tamanhoFonte: 8,
        exibirLogo: true,
        opacidade: 35
      },
      keys: [],
      cliente: {},
      arquivoVisualizacao: {},
    };
  },
  components: {
    KTCodePreview,
    TelaLoading,
    PDFJSViewer,
  },
  computed: {
    colorBotao() {
      if (this.marcaConfig?.corFonte == null) return "rgba(255, 0, 0, 1)";
      const colorRgba = this.marcaConfig?.corFonte;
      return `rgba(${colorRgba.r}, ${colorRgba.g},${colorRgba.b}, ${colorRgba.a})`;
    },
  },
  methods: {
    async obterPropriedades() {
      const retorno =
        await MarcaDocumentoConfigService.getProperiedadesMarcaDocumentoConfig();
      this.keys = retorno.data;
    },
    async obterConfiguracao() {
      const retorno = await MarcaDocumentoConfigService.getMarcaDocumentoConfig(
        this.cliente.id
      );
      const opacidade = retorno.data.opacidade*100;
      this.marcaConfig = { ...retorno.data,opacidade };
      this.picker = { ...retorno.data.corFonte };
      this.obterPrevisualizacao();
    },
    async salvarConfiguracao() {
      const configuracao = {...this.marcaConfig};
      configuracao.clienteID = this.cliente.id;
      configuracao.opacidade = this.marcaConfig.opacidade/100;      
      this.saving = true;
      await MarcaDocumentoConfigService.saveMarcaDocumentoConfig(configuracao);
      this.saving = false;
      this.obterPrevisualizacao();
    },
    definirCorMarcaConfig(cor) {
      const colorRgba = cor.rgba;
      this.marcaConfig.corFonte = { ...colorRgba };
    },
    keyClick(valor) {
      const textAreaComponente = this.$refs["text-marca"];
      const textArea = textAreaComponente?.$refs?.input;
      if (!textArea) return;
      const textoStart = textArea.value.substring(0, textArea.selectionStart);
      const textoEnd = textArea.value.substring(
        textArea.selectionEnd,
        textArea.textLength
      );
      this.marcaConfig.marcaTemplate = `${textoStart}{${valor}}${textoEnd}`;
    },
    exibirColorPick(state) {
      this.showColorPick = state;
    },
    eventoClick(e) {
      const containerPicker = this.$refs?.colorPickRef?.$refs?.link;
      if (containerPicker && e.target.contains(containerPicker)) {
        this.exibirColorPick(false);
      }
    },
    inputClick(e) {
      if (e.target.type == "button" || e.target.parentElement.type == "button")
        this.exibirColorPick(!this.showColorPick);
    },

    async obterPrevisualizacao() {
      const opacidade = this.marcaConfig.opacidade/100;
      const configuracao = {...this.marcaConfig,opacidade};
      configuracao.clienteID = this.cliente.id;
      this.saving = true;
      const arquivo =
        await MarcaDocumentoConfigService.visualizarMarcaDocumentoConfig(
          configuracao
        );
      this.saving = false;
      this.arquivoVisualizacao = arquivo;
    },
  },
  mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    window.addEventListener("click", this.eventoClick);
    this.obterPropriedades();
    this.obterConfiguracao();
  },
  created() {},
  unmounted() {
    window.removeEventListener("click", this.eventoClick);
  },
};
</script>
<style scoped>
button#color-pick {
  position: relative;
}

button#color-pick div.v-color-picker {
  position: absolute;
  top: 2rem;
  left: -150;
}
</style>
